import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReplace(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.858 7.679C6.708 8.719 6 10.091 6 11.5a1 1 0 1 1-2 0c0-2.09 1.042-3.97 2.517-5.304C7.99 4.863 9.973 4 12 4c2.027 0 3.856.862 5.156 1.82.217.16.424.326.616.493l1.02-1.02A1 1 0 0 1 20.5 6v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-.707-1.707l.56-.561c-.12-.1-.248-.202-.384-.302C14.894 6.638 13.473 6 12 6c-1.473 0-2.99.637-4.142 1.679Zm8.284 8.642C17.292 15.281 18 13.909 18 12.5a1 1 0 1 1 2 0c0 2.09-1.042 3.97-2.517 5.304C16.01 19.137 14.027 20 12 20c-1.924 0-3.633-.776-4.853-1.715a8.098 8.098 0 0 1-.552-.466l-.888.888A1 1 0 0 1 4 18v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 .707 1.707l-.696.697c.11.1.23.198.356.296C9.32 17.433 10.61 18 12 18c1.473 0 2.99-.637 4.142-1.679Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
